import { useEffect, useState } from "react";
import { SourceStatsRow } from "../../../api/ParsersPanel";
import { useUserState } from "../../../store/user/hooks";

interface State {
  rows: SourceStatsRow[];
  loading: boolean;
  error: string | null;
}

type Fetcher = (token: string, days: number, threshold?: number) => Promise<SourceStatsRow[]>;

/**
 * Generic hook used by every "<source> Sources Health" tab.
 * Pass the API fetcher (e.g. ParsersPanel.getTamrurSources) and the
 * comparison window. Omit threshold to let the backend use whatever
 * PARSERS_DROP_THRESHOLD_PCT is set to in .env.
 */
export function useSourceStats(fetcher: Fetcher, days = 7, threshold?: number): State {
  const { token } = useUserState();
  const [state, setState] = useState<State>({
    rows: [],
    loading: true,
    error: null,
  });

  useEffect(() => {
    if (!token) return;
    setState((s) => ({ ...s, loading: true, error: null }));

    fetcher(token, days, threshold)
      .then((rows) => setState({ rows, loading: false, error: null }))
      .catch((err) => {
        const msg =
          err?.response?.data?.error ||
          err?.message ||
          "Failed to load source stats";
        setState({ rows: [], loading: false, error: msg });
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, days, threshold]);

  return state;
}
